import { render, staticRenderFns } from "./lease.vue?vue&type=template&id=08aff1c5&"
import script from "./lease.vue?vue&type=script&lang=js&"
export * from "./lease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports